<template>
	<div class="baseBody relative">
		<div class="dateWeek">
			<DynamicDate></DynamicDate>
		</div>
		<div class="topHead flex justify-between">
			<div class="leftHead"></div>
			<div class="midHead">大数据看板数据汇总</div>
			<div class="rightHead"></div>
		</div>
		<div id="main"></div>
		<div class="circle">
			<div class="relative" style="height: 1080px;">
				<div class="circle1"></div>
				<div class="circle2"></div>
				<div class="circle3"></div>
				<div class="circle4"></div>
			</div>
		</div>
		<div class="leftMessageBox">
			<div class="neiBox text-white">
				<div class="base-font-16 text-bold text-center">这是数据内容</div>
				<div class="base-font-14 margin-top-10" style="line-height:1.7;">
					这是数据内容这是数据内容这是数据内容这是数据内容这是数据内容这是数据内容这是数据内容这是据内容这是数据内容这是数据内容这是数据内容</div>
			</div>
		</div>
		<div class="zwRightBox2"></div>
		<div class="zwRightBox">
			<div class="flex  align-center flex-wrap" style="height:100vh;padding:110px 0 40px 30px;">
				<div class="zwRightMneuItem" v-for="(item,index) in rightMenuList" :key="index"
					:style="'margin-left:'+item.left+'px;'">
					<div class="text-center text-white text-bold base-font-24">{{item.name}}</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogTableVisible" width="800px" customClass="mapTcStyle">
			<template v-if="dialogTableVisible">
				<dv-border-box-10 :color="['#064a80', '#01e3eb']" title="dv-border-box-11">
					<div
						style="box-sizing: border-box;padding:5px;background: #051b35;box-shadow:0 0 30px inset #064a80;border-radius:60px;">
						<div class="tcNeiBox" style="width:100%;height:450px;border-radius:20px;">
							<div class="text-center tcNeiTitle text-white">这是标题这是标题这是标题这是标题</div>
							<div style="padding:15px 25px;box-sizing:border-box;">
								<div class="flex align-center justify-between">
									<div>
										<div class="leftImage">
											<el-image style="width:480px; height:340px" :src="tcltImage" fit="fill">
											</el-image>
										</div>
									</div>
									<div>
										<div class="textInfo gdt ">
											这是文字这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍这是文字介绍
										</div>
									</div>


								</div>
							</div>
						</div>
					</div>

				</dv-border-box-10>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	import DynamicDate from "../../components/dynamicDate/index.vue";
	import china from "echarts/map/json/china";
	// import * as myEchart from 'echarts';
	export default {
		components: {
			DynamicDate,
		},
		data() {
			return {
				tcltImage: require('@/assets/images/11.png'),
				dialogTableVisible: false,
				showData: [{
					"name": "安徽省",
					"value": [3, 2],
					"coords": [
						[117.29, 31.86],
						[121.29, 38.86]
					]
				}, {
					"name": "贵州省",
					"value": [135, 3],
					"coords": [
						[106.71, 26.6],
						[110.71, 33.6]
					]
				}],
				showData2: [{
					"name": "贵州省",
					"value": [135, 3],
					"coords": [
						[106.71, 26.6],
						[110.71, 33.6]
					]
				}],
		
				sfListData:[{
					"name": "合肥市",
					"value": [29, 31],
					"coords": [
						[117.31,31.86],
						[117.32,31.90]
					]
				}],
				sfListData2:[{
					"name": "芜湖",
					"value": [29, 31],
					"coords": [
						[117.31,31.86],
						[117.32,31.90]
					]
				}],
				rightMenuList: [{
						id: 1,
						name: "大屏看板按钮一",
						left: 70
					},
					{
						id: 1,
						name: "大屏看板按钮一",
						left: 30
					},
					{
						id: 1,
						name: "大屏看板按钮一",
						left: 0
					},
					{
						id: 1,
						name: "大屏看板按钮一",
						left: 0
					},
					{
						id: 1,
						name: "大屏看板按钮一",
						left: 30
					},
					{
						id: 1,
						name: "大屏看板按钮一",
						left: 60
					}
				],
				provinces: {
					全国: require("echarts/map/json/china.json"),
					上海: require("echarts/map/json/province/shanghai.json"),
					河北: require("echarts/map/json/province/hebei.json"),
					山西: require("echarts/map/json/province/shanxi.json"),
					内蒙古: require("echarts/map/json/province/neimenggu.json"),
					辽宁: require("echarts/map/json/province/liaoning.json"),
					吉林: require("echarts/map/json/province/jilin.json"),
					黑龙江: require("echarts/map/json/province/heilongjiang.json"),
					江苏: require("echarts/map/json/province/jiangsu.json"),
					浙江: require("echarts/map/json/province/zhejiang.json"),
					安徽: require("echarts/map/json/province/anhui.json"),
					福建: require("echarts/map/json/province/fujian.json"),
					江西: require("echarts/map/json/province/jiangxi.json"),
					山东: require("echarts/map/json/province/shandong.json"),
					河南: require("echarts/map/json/province/henan.json"),
					湖北: require("echarts/map/json/province/hubei.json"),
					湖南: require("echarts/map/json/province/hunan.json"),
					广东: require("echarts/map/json/province/guangdong.json"),
					广西: require("echarts/map/json/province/guangxi.json"),
					海南: require("echarts/map/json/province/hainan.json"),
					四川: require("echarts/map/json/province/sichuan.json"),
					贵州: require("echarts/map/json/province/guizhou.json"),
					云南: require("echarts/map/json/province/yunnan.json"),
					西藏: require("echarts/map/json/province/xizang.json"),
					陕西: require("echarts/map/json/province/shanxi1.json"),
					甘肃: require("echarts/map/json/province/gansu.json"),
					青海: require("echarts/map/json/province/qinghai.json"),
					宁夏: require("echarts/map/json/province/ningxia.json"),
					新疆: require("echarts/map/json/province/xinjiang.json"),
					北京: require("echarts/map/json/province/beijing.json"),
					天津: require("echarts/map/json/province/tianjin.json"),
					重庆: require("echarts/map/json/province/chongqing.json"),
					香港: require("echarts/map/json/province/xianggang.json"),
					澳门: require("echarts/map/json/province/aomen.json"),
					台湾: require("echarts/map/json/province/taiwan.json"),
				},
				
				jsonList: [{
						name: "南海诸岛"
					},
					{
						ename: "beijing",
						name: "北京"
					},
					{
						ename: "tianjin",
						name: "天津"
					},
					{
						ename: "shanghai",
						name: "上海"
					},
					{
						ename: "chongqing",
						name: "重庆"
					},
					{
						ename: "hebei",
						name: "河北"
					},
					{
						ename: "henan",
						name: "河南"
					},
					{
						ename: "yunnan",
						name: "云南"
					},
					{
						ename: "liaoning",
						name: "辽宁"
					},
					{
						ename: "heilongjiang",
						name: "黑龙江"
					},
					{
						ename: "hunan",
						name: "湖南"
					},
					{
						ename: "anhui",
						name: "安徽"
					},
					{
						ename: "shandong",
						name: "山东"
					},
					{
						ename: "xinjiang",
						name: "新疆"
					},
					{
						ename: "jiangsu",
						name: "江苏"
					},
					{
						ename: "zhejiang",
						name: "浙江"
					},
					{
						ename: "jiangxi",
						name: "江西"
					},
					{
						ename: "hubei",
						name: "湖北"
					},
					{
						ename: "guangxi",
						name: "广西"
					},
					{
						ename: "gansu",
						name: "甘肃"
					},
					{
						ename: "shanxi",
						name: "山西"
					},
					{
						ename: "neimenggu",
						name: "内蒙古"
					},
					{
						ename: "shanxi1",
						name: "陕西"
					},
					{
						ename: "jilin",
						name: "吉林"
					},
					{
						ename: "fujian",
						name: "福建"
					},
					{
						ename: "guizhou",
						name: "贵州"
					},
					{
						ename: "guangdong",
						name: "广东"
					},
					{
						ename: "qinghai",
						name: "青海"
					},
					{
						ename: "xizang",
						name: "西藏"
					},
					{
						ename: "sichuan",
						name: "四川"
					},
				 {
						ename: "ningxia",
						name: "宁夏"
					},
					{
						ename: "hainan",
						name: "海南"
					},
					{
						name: "台湾"
					},
					{
						ename: "xianggang",
						name: "香港"
					},
					{
						ename: "aomen",
						name: "澳门"
					},
				],

			}
		},
		mounted() {
			this.$nextTick(() => {
				this.initMap()
				
			})
		},
		methods: {
			initMap() {
				let myChart = this.$echarts.init(document.getElementById("main"));
				let iconRQ =
					'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjNCRkRBMEJBQzgwRjExRUFBNUI0RTMyMThEN0UxMzFEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjNCRkRBMEJCQzgwRjExRUFBNUI0RTMyMThEN0UxMzFEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6M0JGREEwQjhDODBGMTFFQUE1QjRFMzIxOEQ3RTEzMUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6M0JGREEwQjlDODBGMTFFQUE1QjRFMzIxOEQ3RTEzMUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5mT42iAAABQ0lEQVR42mL8LabOQCQIBOL1xChkItJAkLp+IBajpqFWQCwPxJ7UNDQCSgdQy1BmIA6Bsl2AmJMahjoAsTiUzQPETtQwNAKN709IAwvUayZQ/hcg/o0k/x6Ig9D0+ABxKJT9HYh/oMm/BBm6GYitgTgfiBmJcLkkEK/CIXcGiGNB3v8JxIVQF31gIA/8AeIWaNK7gRymG4BYH4hPkGjgXSC2A+JaWNChR9QjqIJeIP5PhIGzgdgAiI8Tin2QbSVAvIOAgROBOA0auUQlKV4gtidgqBGp6RSUFrmIKA/ESDEUPcGfBOIUIH6Lln29iTVUCIjdkJJKExDbAPFcqJdPEMpd2AwF5TBWaFKxBeJ6qOHIqaMbmjrcsBUw2AwNh7rKAEeaBaWOMiD2BeJvQOxOyFBuaFJJwZZU0MBWaHCIo0sABBgAetA4Jx5t/ToAAAAASUVORK5CYII=';

				let _self = this
				// 注册的是中国地图，必须包括geo组件或者mep图标类型的时候才可以使用
				// 地图：世界地图，中国地图，省份地图，市区地图
				this.$echarts.registerMap("china", china);
				myChart.setOption({
					// 背景色
					// backgroundColor: "rgb(121,145,200)",
					// 配置项(组件)
					geo: {
						map: "china",
						// 地图的长宽比例
						aspectScale: 0.75,
						// 图层
						zoom: 1.1,
						// 样式
						itemStyle: {
							normal: {
								borderColor: "#80c4dc",
								borderWidth: 5,
								areaColor: 'rgba(7,34,124,0.8)',
								fontWeightL: 700,
								shadowColor: 'rgba(19, 59,165, 1)',
								shadowOffsetX: -2,
								shadowOffsetY: 2,
								shadowBlur: 10
							},
							emphasis: {
								areaColor: '#389BB7',
								borderWidth: 0
							},
						},
						region: [{
							name: "南海诸岛",
							itemStyle: {
								opacity: 0,
							},
						}, ],
					},
					series: [
						// 配置地图相关的数据参数
						{
							type: "map",
							label: {
								normal: {
									// 显示文字
									show: true,
									textStyle: {
										color: "#1DE9B6",
									},
								},
								emphasis: {
									textStyle: {
										color: "rgb(183,185,14)",
									},
								},
							},
							data: this.showData2,
							// 图层
							zoom: 1.1,
							map: "china",
							itemStyle: {
								normal: {
									// areaColor: 'rgba(5,41,134,0.9)',
									areaColor: {
										colorStops: [{
												offset: 0,
												color: "rgb(5,108,236)"
											},
											{
												offset: 1,
												color: "rgb(5,41,134)"
											},
										],
									},
									borderColor: '#fff',
									fontWeightL: 700,

									borderWidth: 1,

								},
								// 高亮效果
								emphasis: {
									areaColor: "rgb(46,229,206)",
									borderWidth: 0.1,
								},
							},
						},
						{ //首都星图标
							name: '首都',
							type: 'scatter',
							coordinateSystem: 'geo',
							data: [{
								name: '首都',
								value: [116.24, 41.55, 100]
							}],
							symbol: iconRQ,
							symbolSize: 20,
							label: {
								normal: {
									show: false
								},
								emphasis: {
									show: false
								}
							}
						},
						// 区域散点图
						{
							type: 'effectScatter',
							coordinateSystem: 'geo',
							zlevel: 2,
							symbolSize: 10,
							rippleEffect: { //坐标点动画
								period: 3,
								scale: 5,
								brushType: 'fill'
							},
							label: {
								normal: {
									show: true,
									position: 'right',
									formatter: '{b}',
									color: '#b3e2f2',
									fontWeight: 'bold',
									fontSize: 16
								}
							},
							data: this.showData2,
							itemStyle: { //坐标点颜色
								normal: {
									show: true,
									color: '#ff8003',
									shadowBlur: 20,
									shadowColor: '#fff'
								},
								emphasis: {
									areaColor: '#f00'
								}
							}
						},
						{
							type: 'lines',
							zlevel: 3,
							symbol: 'circle',
							symbolSize: [5, 5],
							color: '#ff8003',
							opacity: 1,
							label: {
								show: true,
								padding: [10, 20],
								color: '#fff',
								backgroundColor: '#1a3961',
								borderColor: '#aee9fb',
								borderWidth: 1,
								borderRadius: 6,
								formatter(params) {
									let arr = [params.name, '站点个数：' + params.value[1] + '家', '用户数' + params
										.value[0] + '人'
									];
									return arr.join('\n');
								},
								textStyle: {
									align: 'left',
									lineHeight: 20
								}
							},
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: 0.5,
								opacity: 1
							},
							data: this.sfListData
						}
					],
				});
				myChart.on("click", function(params) { //点击事件
					if (params.componentSubType == "lines") {
						_self.dialogTableVisible = true
					} else if (params.componentSubType == "effectScatter") {
						console.log('进入下个城市', params)
					
					}
					console.log('我被点击了', params)
					console.log(params.name, 111)
					let ename=_self.findSfName(params.name)
					console.log(ename,222)
					_self.initMapSf(params.name) 
					
					
					// _self.initMapSf("安徽")

				});
			},


		initMapSf(key) {
					
				// let obj=document.getElementById("main")
				// obj.innerHTML=''
				let myChart = this.$echarts.init(document.getElementById("main"));
				
				let _self = this
				// 注册的是中国地图，必须包括geo组件或者mep图标类型的时候才可以使用
				// 地图：世界地图，中国地图，省份地图，市区地图
				// this.$echarts.registerMap("anhui", this.provinces['安徽']);

				this.$echarts.registerMap(_self.findSfName(key), this.provinces[key]);
				myChart.setOption({
					// 背景色
					// backgroundColor: "rgb(121,145,200)",
					// 配置项(组件)
					geo: {
						map: "anhui",
						// 地图的长宽比例
						aspectScale: 0.75,
						// 图层
						zoom: 1.1,
						// 样式
						itemStyle: {
							normal: {
								borderColor: "#80c4dc",
								borderWidth: 5,
								areaColor: 'rgba(7,34,124,0.8)',
								fontWeightL: 700,
								shadowColor: 'rgba(19, 59,165, 1)',
								shadowOffsetX: -2,
								shadowOffsetY: 2,
								shadowBlur: 10
							},
							emphasis: {
								areaColor: '#389BB7',
								borderWidth: 0
							},
						},
						region: [{
							name: "南海诸岛",
							itemStyle: {
								opacity: 0,
							},
						}, ],
					},
					series: [
						// 配置地图相关的数据参数
						{
							type: "map",
							label: {
								normal: {
									// 显示文字
									show: true,
									textStyle: {
										color: "#1DE9B6",
									},
								},
								emphasis: {
									textStyle: {
										color: "rgb(183,185,14)",
									},
								},
							},
							data: this.sfListData,
							// 图层
							zoom: 1.1,
							map: "anhui",
							itemStyle: {
								normal: {
									// areaColor: 'rgba(5,41,134,0.9)',
									areaColor: {
										colorStops: [{
												offset: 0,
												color: "rgb(5,108,236)"
											},
											{
												offset: 1,
												color: "rgb(5,41,134)"
											},
										],
									},
									borderColor: '#fff',
									fontWeightL: 700,

									borderWidth: 1,

								},
								// 高亮效果
								emphasis: {
									areaColor: "rgb(46,229,206)",
									borderWidth: 0.1,
								},
							},
						},
						
			
						{
							type: 'lines',
							zlevel: 3,
							symbol: 'circle',
							symbolSize: [5, 5],
							color: '#ff8003',
							opacity: 1,
							label: {
								show: true,
								padding: [10, 20],
								color: '#fff',
								backgroundColor: '#1a3961',
								borderColor: '#aee9fb',
								borderWidth: 1,
								borderRadius: 6,
								formatter(params) {
									let arr = [params.name, '站点个数：' + params.value[1] + '家', '用户数' + params
										.value[0] + '人'
									];
									return arr.join('\n');
								},
								textStyle: {
									align: 'left',
									lineHeight: 20
								}
							},
							lineStyle: {
								type: 'solid',
								color: '#fff',
								width: 0.5,
								opacity: 1
							},
							data: this.sfListData2
						}
					],
				});
				myChart.on("click", function(params) { //点击事件
					if (params.componentSubType == "lines") {
						_self.dialogTableVisible = true
					} else if (params.componentSubType == "effectScatter") {
						
						console.log('进入下个城市', params)
					}
					
				
					
					
					
					console.log('我被点击了', params)
					console.log(params.name, 111)

				});
			},



			findSfName(name){
				let ename=''
				this.jsonList.forEach(item =>{
					if(item.name==name+''){
						ename=item.ename
					}
				})
				return ename
			}


		}
	}
</script>

<style>
	.mapTcStyle {
		background: none !important;
		box-sizing: border-box;
		border-radius: 20px;
	}

	.tcNeiTitle {
		font-size: 22px;
		height: 50px;
		padding-top: 30px;
		font-weight: bold;
		color: #69f5ff;
	}

	.tcNeiBox .leftImage {
		width: 500px;
		height: 360px;
		padding: 10px;
		box-sizing: border-box;
		box-shadow: 0 0 20px inset #2281c4;
		;
	}

	.textInfo {
		height: 360px;
		width: 180px;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 1.9;
		overflow-y: auto;
		padding-right: 10px;
		box-sizing: border-box;
	}

 
	 #mapSf{
		 width: 100%;
		 height: calc(100vh - 105px);
		 position: relative;
	 }


	#main {
		width: 100%;
		height: calc(100vh - 105px);
		position: relative;
	}

	#main::before {
		position: absolute;
		content: '';
		width: 100%;
		height: 100%;
		background: url('../../assets/images/allBg.png') 20px 150px no-repeat;
		background-size: 100% 100%;
		bottom: 0;
		left: 0;
		opacity: 0.5;
	}

	.leftMessageBox {
		position: absolute;
		left: 20px;
		z-index: 999;
		bottom: 50px;
		width: 360px;
		height: 185px;
		background: url('../../assets/images/leftBox.png') center no-repeat;
		background-size: 100% 100%;
		padding: 22px 31px;
	}

	.circle {
		width: 780px;
		height: 780px;
		position: absolute;
		left: -30%;
		top: calc(50% - 390px);
		opacity: 0.5;
		transform: scale(0.7);
		-o-transform: rotate(0.7);
		-webkit-transform: rotate(0.7);
		-moz-transform: rotate(0.7);

	}

	.circle1 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle1.png')center no-repeat;
		background-size: 100% 100%;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle2 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle2.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle3 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle3.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst 15s infinite linear;
		-webkit-animation: myfirst 15s infinite linear;
		/* Safari and Chrome */
	}

	.circle4 {
		width: 780px;
		height: 780px;
		background: url('../../assets/images/circle4.png')center no-repeat;
		background-size: 100% 100%;
		left: 0;
		top: 0;
		position: absolute;
		animation: myfirst2 15s infinite linear;
		-webkit-animation: myfirst2 15s infinite linear;
		/* Safari and Chrome */
	}

	.dateWeek {
		position: absolute;
		top: 0;
		left: 0;
		width: 200px;
		height: 50px;
		color: #ffffff;
	}

	.leftMessageBox .neiBox {
		box-shadow: 0 0 50px inset rgba(0, 151, 255, 1);
		height: 140px;
		border-radius: 20px;
		padding: 17px;
		box-sizing: border-box;
	}

	.baseBody {
		width: 100%;
		height: 100vh;
		background: #000208 url('../../assets/images/bg1.png') center no-repeat;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.zwRightBox {
		width: 340px;
		height: calc(100vh - 0);
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		border-radius: 260px 0 0 160px/350px 0 0 300px;
		background: url('../../assets/images/leftBoxbg.png') center no-repeat;
		;
		background-size: 100% 100%;
		/* background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Safari 5.1 - 6.0 */
		/*  background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Opera 11.1 - 12.0 */
		/*  background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Firefox 3.6 - 15 */
		/* background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* 标准的语法 */
	}

	.zwRightBoxLine {
		width: 2px;
		height: 200px;
	}

	.zwRightMneuItem {
		background: url('../../assets/images/btnNormal.png') center no-repeat;
		background-size: 100% 100%;
		width: 230px;
		height: 62px;
		line-height: 62px;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1);
		-webkit-transform: scale(1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1);
	}

	.zwRightMneuItem:hover {
		background: url('../../assets/images/btnNormalChecked.png') center no-repeat;
		background-size: 100% 100%;
		cursor: pointer;
		transition: transform 0.5s;
		-webkit-transition: transform 0.5s;
		transform: scale(1.1);
		-webkit-transform: scale(1.1);
		/*兼容-webkit-引擎浏览器*/
		-moz-transform: scale(1.1);
	}

	.topHead {
		width: 100%;
		height: 103px;
	}

	.topHead .leftHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/leftTop.png') center no-repeat;
		background-size: 100% 100%;
	}

	.topHead .midHead {
		width: 44%;
		height: 103px;
		background: url('../../assets/images/midTop.png') center no-repeat;
		background-size: 100% 100%;
		text-align: center;
		font-weight: bold;
		font-size: 38px;
		line-height: 93px;
		color: #FFFFFF;
	}

	.topHead .rightHead {
		width: 28%;
		height: 81px;
		background: url('../../assets/images/rightTop.png') center no-repeat;
		background-size: 100% 100%;
	}
</style>
